import { ILandingSection, TableContent } from "src/modules/pe-landing-module/data/interfaces"
import TableTreadCell from "./TableTreadCell"

/* Protopia Ecosystem component */
export interface ITableThreadProps {
    primitive: TableContent
    section?: ILandingSection 
}
const TableThread = (props: ITableThreadProps): JSX.Element => {
    return <thead className="">
        <tr>
        {
            props.primitive.threads?.cells.map((th, i) => <TableTreadCell 
                rowOrder={i} 
                key={ th.id } 
                th={th} 
                section={ props.section! } 
                primitive={ props.primitive }  
            />)
        }
        </tr>
    </thead> 
}
export default TableThread 